module.exports = __webpack_public_path__ + "img/facebook.f3586ce6.svg";